import type { Band } from '../../api/types'
import { BAND_ORDER, bandMeta } from '../../lib/bands'
import type { DashboardFilters } from './models'

interface Props {
  filters: DashboardFilters
  onChange: (filters: DashboardFilters) => void
  onReset: () => void
  showReset: boolean
}

/** Search submits explicitly; condition changes immediately. Both target only the equipment list. */
export function EquipmentListFilters({ filters, onChange, onReset, showReset }: Props) {
  return (
    <form className="toolbar" onSubmit={(e) => {
      e.preventDefault()
      const search = String(new FormData(e.currentTarget).get('search') ?? '').trim()
      onChange({ ...filters, search: search || undefined })
    }}>
      <label className="select-pill">Condición del equipo
        <select value={filters.band ?? ''} onChange={(e) => onChange({ ...filters, band: (e.target.value || undefined) as Band | undefined })}>
          <option value="">Todas las condiciones</option>
          {BAND_ORDER.map((band) => <option key={band} value={band}>{bandMeta(band).label}</option>)}
        </select>
      </label>
      <label className="field">Buscar por nombre o código
        <input key={filters.search ?? ''} name="search" defaultValue={filters.search ?? ''} placeholder="Nombre o código del equipo" />
      </label>
      <button type="submit" className="btn">Buscar equipos</button>
      {showReset ? <button type="button" className="btn" onClick={onReset}>Limpiar filtros de equipos</button> : null}
    </form>
  )
}
